import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadAlertComponent } from './download-alert/download-alert.component';
import { FormDialogComponent } from '../shared/form-dialog/form-dialog.component';



@NgModule({
  declarations: [
    DownloadAlertComponent
  ],
  imports: [
    CommonModule,
    FormDialogComponent
  ],
  exports: [
  ]
})
export class SMOLinkModule { }
